import { loginRequest, msalInstance } from "../authConfig";

export async function getBearerToken() {
  const account = msalInstance?.getActiveAccount();
  if (!account) {
    throw Error(
      "No active account! Verify a user has been signed in and setActiveAccount has been called."
    );
  }

  let response;
  try {
    response = await msalInstance?.acquireTokenSilent({
      ...loginRequest,
      account: account,
    });
  } catch (error) {
    await msalInstance?.loginRedirect();
  }

  const bearer = `Bearer ${response?.accessToken}`;

  return bearer;
}
